import { getDayDifference, getTimeInDate } from '../utils/date.utils';

export class Check {
  private diff: number;

  constructor(
    public hash: string,
    public startTime: number,
    public endTime: number,
    public observations: string,
    public user: string,
    public startLatitude: number = null,
    public startLongitude: number = null,
    public endLatitude: number = null,
    public endLongitude: number = null
  ) { }

  getTimeInDate(reference: number) {
    return (this.endTime) ? getTimeInDate(this.startTime, this.endTime, reference) : 0;
  }

  getStartDayDifference(reference: number) {
    return getDayDifference(this.startTime, reference);
  }

  getEndDayDifference(reference: number) {
    return getDayDifference(this.endTime, reference);
  }

  get timeDifference() {
    const diff = this.endTime - this.startTime;

    return (diff > 0) ? diff : 0;
  }

  get hasStartPoint() {
    return this.startLatitude && this.startLongitude;
  }

  get hasEndPoint() {
    return this.endLatitude && this.endLongitude;
  }

  set serverDiff(diff: number) {
    this.diff = diff;
  }

  get correctedTime() {
    return this.startTime + this.diff;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/check.ts